export enum UIComponents {
    Balance = "balance_amount",
    BalanceAlternative = "balance_amountAlt",

    Win = "win_amount",
    WinAlternative = "win_amountAlt",

    TotalWin = "total_win_amount",
    TotalWinAlternative = "total_win_amountAlt",

    TotalBet = "bet_amount",
    TotalBetAlternative = "bet_amountAlt",

    AutoCounter = "auto_counter",
    AutoCounterBg = "new_autotab",
    TotalWinLabel = "total_win",
    TotalWinAmount = "total_win_amount",
    BetInfoGroup = "bet_info",
    FreeGamesInfoGroup = "free_games_info",
    FreeGames = "freeGames_amount",
    FreeSpinsInfoGroup = "free_spins_info",

    FreeSpins = "freeSpins_amount",
    FreeSpinsAlternative = "freeSpins_amountAlt",
    
    WinInfoGroup = "win_info"
}
